module.exports = __webpack_public_path__ + "static/media/tools-devmode.3c7613e0.svg";